<template>
  <div
    class="modal fade createNewModal"
    id="AddArrieresModal"
    tabindex="-1"
    aria-hidden="true"
    ref="addArrieresMondalRef"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">Détails</h5>
        </div>
        <Form
          ref="contratForm"
          @submit="soumission"
          :validation-schema="contratSchema"
        >
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    N° Compte <span class="text-danger">*</span> :
                    {{ numCompte }}
                  </label>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Emplacement <span class="text-danger">*</span> :
                    {{ emplace }}
                  </label>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Total d'arrièrés <span class="text-danger">*</span> :
                    <span class="fw-bold text-black">{{ total }}</span>
                  </label>
                </div>
              </div>
              <div class="col-md-8">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Locataire <span class="text-danger">*</span> :
                    {{ locataire }}
                  </label>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <div>
                    <button
                      type="button"
                      class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                      @click="ajouterElement(null)"
                    >
                      <i class="flaticon-plus position-relative ms-5 fs-12"></i
                      >Ajouter
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <Field
                    name="nombreA"
                    type="text"
                    v-model="nombreA"
                    placeholder="Années"
                    class="form-control shadow-none fs-md-15 text-black"
                  />
                  <ErrorMessage name="nombreA" class="text-danger" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" v-if="elements.length > 0">
                <div class="row">
                  <div class="col-10">
                    <div class="row">
                      <div class="col">
                        <div class="form-group mb-10 mb-sm-15 mb-md-18">
                          <label class="d-block text-black fw-semibold mb-10">
                            Année <span class="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group mb-10 mb-sm-15 mb-md-18">
                          <label class="d-block text-black fw-semibold mb-10">
                            Loyer <span class="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group mb-10 mb-sm-15 mb-md-18">
                          <label class="d-block text-black fw-semibold mb-10">
                            Nmbre Mois <span class="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group mb-10 mb-sm-15 mb-md-18">
                          <label class="d-block text-black fw-semibold mb-10">
                            Montant <span class="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-1">
                    <div class="form-group mb-10 mb-sm-15 mb-md-18 --center">
                      <label class="d-block text-black fw-semibold mb-10">
                        2 taux ?
                      </label>
                    </div>
                  </div>
                  <div class="col-1">
                    <div class="form-group mb-10 mb-sm-15 mb-md-18">
                      <label
                        class="d-block text-black fw-semibold mb-10"
                        style="opacity: 0"
                      >
                        _
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div v-for="(element, index) in elements" :key="index">
                  <ElementVue
                    :element="element"
                    :options="options"
                    @elementmodif="elementModified"
                    @somme="faireSomme"
                    @elementModifNombre="elementModified"
                    @sortie="supprimerElement"
                    @auchangement="auchangement"
                    @close="vider"
                    @auCoche="supprimerElement"
                    @verifiSommeMois="verifierNombreMois"
                    @suppression="retirerElement"
                    @modification="mettreAJourElement"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-10 text-left">
                <button
                  v-if="elements.length > 0"
                  class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                  type="submit"
                >
                  Enregistrer
                </button>
              </div>
              <div class="col-md-2">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <div>
                    <button
                      v-if="elements.length > 0"
                      type="button"
                      class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                      @click="ajouterElement(null)"
                    >
                      <i class="flaticon-plus position-relative ms-5 fs-12"></i
                      >Ajouter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
        <button
          type="button"
          class="btn-close shadow-none"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="vider"
        ></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import Multiselect from "@vueform/multiselect";
import ApiService from "@/services/ApiService";
import Swal from "sweetalert2";
import ElementVue from "./ElementVue.vue";
import { Option, Ele } from "@/models/Option";
import { Element } from "@/models/Element";
import { hideModal, showModal, success, error, warning } from "@/utils/utils";
import * as Yup from "yup";
import axios from "axios";

export default defineComponent({
  name: "AddArrieresMondal",
  components: {
    ElementVue,
    Form,
    Field,
    ErrorMessage,
  },
  props: {
    item: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  setup: (props, { emit }) => {
    const elements = ref<Array<Element>>([]);
    const addArrieresMondalRef = ref<null | HTMLElement>(null);
    const options = ref<Array<Option>>([]);
    const date = new Date();
    var anneeActuelle = date.getFullYear();
    const lien = ref("/arrierres");
    const charge = () => {
      options.value = [];
      for (let i = 0; i <= 20; i++) {
        options.value.push({
          value: anneeActuelle - i,
          label: anneeActuelle - i,
          disabled: false,
        });
      }
    };
    charge();

    const nombreA = ref<any>(null);
    const contratSchema = Yup.object().shape({
      //   nombreA: Yup.number().typeError('Veuillez entrer un nombre').nullable(),
    });
    const taux = ref();
    const contratId = ref();

    const recupereContrat = async (id: number) => {
      try {
        const response = await axios.get(`/contrat/${id}`);
        const donneee = response.data.data;
        locataire.value = donneee[0].locataire;
        emplace.value = donneee[0].ncode_emp;
        numCompte.value = donneee[0].num_compte;
        taux.value = donneee[0].loyer;
        contratId.value = donneee[0].id;
      } catch (error) {
        //
      }
    };

    const recupereContrat2 = async (id: number) => {
      try {
        const response = await axios.get(`/contrat/getArrieresByContrat/${id}`);
        const donneee = response.data.data;
        locataire.value = donneee[0].locataire;
        emplace.value = donneee[0].codeemp;
        numCompte.value = donneee[0].num_compte;
        taux.value = donneee[0].loyer;
        contratId.value = donneee[0].id;
        donneee.forEach((don) => {
          tableau.value.push(don.arr_annee);
          elements.value.push({
            id: don.arr_id,
            annee: don.arr_annee,
            mois: don.arr_mois,
            loyer: don.arr_taux,
            montant: don.arr_montnat_arr,
            des: false,
            type: true,
          });
        });
      } catch (error) {
        //
      }
    };
    const idContrat = ref();
    watch(
      () => props.item,
      async (newValue) => {
        await vider();
        await charge();
        idContrat.value = newValue;
        if (props.type == "Modification") {
          await recupereContrat2(props.item);
          lien.value = "/arrieres/modification";
          faireSomme();
          mettreAJourOptions();
        }
        if (props.type == "Ajout") {
          lien.value = "/arrieres";
          if (newValue && newValue != null) {
            await recupereContrat(newValue);
            elements.value = [];
            total.value = 0;
            await vider();
            await charge();
          }
        }
      }
    );
    var cpt = 0;
    const ajouterElement = (annee: number | null | undefined = null) => {
      const newElement = {
        id: cpt + 1,
        montant: taux.value * (annee == null ? 0 : 12),
        loyer: taux.value,
        mois: annee == null ? 0 : 12,
        annee: annee == null ? 0 : annee,
        des: annee == null ? false : true,
        type: false,
      };
      elements.value.push(newElement);
      cpt++;
      if (annee !== null) {
        auchangement(annee);
      }
      faireSomme();
    };
    const contratForm = ref([]);
    const tabVerif = ref<Array<Ele>>([]);

    const verifierNombreMois = () => {
      tabVerif.value = [];
      for (let k = 0; k < elements.value.length; k++) {
        var annee = elements.value[k].annee;
        var nMois = 0;
        for (let j = 0; j < elements.value.length; j++) {
          if (elements.value[j].annee === annee) {
            nMois += elements.value[j].mois;
          }
        }
        tabVerif.value.push({ annee: annee, mois: nMois });
      }

      for (let h = 0; h < tabVerif.value.length; h++) {
        if (tabVerif.value[h].mois > 12) {
          Swal.fire({
            icon: "warning",
            title: "Attention",
            text: `Le nombre de mois pour l'année ${tabVerif.value[h].annee} ne doit pas dépasser 12`,
          });

          return false;
        }
      }
    };

    const soumission = async (values: any, contratForm) => {
      values["arrieres"] = elements.value;
      var etatAnnee = true;
      var etatMois = true;
      var etatMontant = true;
      var etatLoyer = true;

      let resultat = verifierNombreMois();
      if (resultat == false) {
        return false;
      }
      for (let k = 0; k < elements.value.length; k++) {
        if (
          !elements.value ||
          !elements.value[k] ||
          !elements.value[k].montant
        ) {
          etatMontant = false;
        }
        if (!elements.value || !elements.value[k] || !elements.value[k].loyer) {
          etatLoyer = false;
        }
        if (!elements.value || !elements.value[k] || !elements.value[k].mois) {
          etatMois = false;
        }
        if (!elements.value || !elements.value[k] || !elements.value[k].annee) {
          etatAnnee = false;
        }
      }
      if ( !etatLoyer ||  !etatAnnee) {
        if (!etatLoyer) {
          Swal.fire({
            icon: "error",
            title: "Erreur",
            text: "Veuillez renseigner tous les taux",
          });
          return;
        }
        if (!etatAnnee) {
          Swal.fire({
            icon: "error",
            title: "Erreur",
            text: "Veuillez renseigner toutes les années",
          });
          return;
        }
      } else {
        values["contrat_id"] = contratId.value;
        const result = await Swal.fire({
          text: `Etes-vous sur de vouloir faire cet arrièré dont le coût global est :  ${total.value} FCFA ?`,
          icon: "warning",
          buttonsStyling: true,
          showCancelButton: true,
          confirmButtonText: "Oui",
          cancelButtonText: `Non`,
          heightAuto: false,
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });

        if (result.isConfirmed) {
         await ApiService.post(lien.value, values)
            .then(({ data }) => {
              if (data.code == 201) {
                success(data.message);
                vider();
                hideModal(addArrieresMondalRef.value);
                emit("close");
              }
            })
            .catch(async ({ response }) => {
              //error(response.data.message);
              const result = await Swal.fire({
                text: response.data.message,
                icon: "error",
                buttonsStyling: true,
                showCancelButton: false,
                heightAuto: false,
              });
            });
        }
      }
    };

    watch(nombreA, (nou, anci) => {
      if (isNaN(nou)) {
        warning("Veuillez saisir un nombre");
        nombreA.value = null;
        return false;
      } else {
        //
      }
      if (nou !== anci && nou != null) {
        const tableau = nou.toString().split("");
        const anAct = anneeActuelle.toString().split("");
        if (
          tableau.length > 3 &&
          tableau.length <= anAct.length &&
          parseInt(nou) < anneeActuelle
        ) {
          var nombre = date.getFullYear() - nou;
          var anne = date.getFullYear();
          if (nombre > 0 && nombre <= 20) {
            elements.value = [];
            for (let i = 0; i < nombre; i++) {
              anne = anne - 1;
              ajouterElement(anne);
            }
            faireSomme();
          }
          if (nombre > 20) {
            warning("Votre année ne doit pas aller à plus de 20 ans");
            vider();
          }
        } else {
          var nombre1 = date.getFullYear() - nou;
          if (nombre1 < 0) {
            warning(
              `Votre année ne doit pas être supérieure ou égale de l'année en cours ${date.getFullYear()}`
            );
          }

          vider();
        }
      }
    });
    const tableau = ref<Array<any>>([]);

    const retirerNullEtUndefined = () => {
      tableau.value = tableau.value.filter(
        (element) => element !== null && element !== undefined
      );
    };
    const mettreAJourOptions = () => {
      for (let j = 0; j < options.value.length; j++) {
        if (tableau.value.includes(options.value[j].value)) {
          options.value[j].disabled = true;
        }
        if (!tableau.value.includes(options.value[j].value)) {
          options.value[j].disabled = false;
        }
      }
    };
    const auchangement = async (nouvelleAnnee: number) => {
      if (!tableau.value.includes(nouvelleAnnee)) {
        tableau.value.push(nouvelleAnnee);
      }
      mettreAJourOptions();
    };
    const supprimerElement = (valeurASupprimer: number) => {
      const element = tableau.value;
      tableau.value = [];
      tableau.value = element.filter((el) => el !== valeurASupprimer);
      mettreAJourOptions();
    };
    const trouverEtModifierObjet = (id, nouvelleValeur) => {
      const index = elements.value.findIndex((element) => element.id === id);
      if (index !== -1) {
        elements.value[index].montant = nouvelleValeur;
      }
    };
    const elementModified = async (element: any, montant: number) => {
      await trouverEtModifierObjet(element.id, montant);
    };

    const modifNombre = (element: any, montant) => {
      trouverEtModifierObjet(element.id, montant);
    };

    const sommeMontant = () => {
      var somme = 0;
      for (let i = 0; i < elements.value.length; i++) {
        const montantAsString: string = elements.value[i].montant.toString();
        somme += parseFloat(montantAsString);
      }
      return somme;
    };

    const total = ref();
    const faireSomme = () => {
      total.value = sommeMontant();
    };
    const retirerElement = (id: number) => {
      if (id) {
        const index = elements.value.findIndex((element) => element.id === id);
        const element = elements.value;
        for (let j = 0; j < element.length; j++) {
          if (element[j].id == id) {
            supprimerElement(element[j].annee);
          }
        }
        for (let i = 0; i < elements.value.length; i++) {
          elements.value.splice(index, 1);
          break;
        }
        faireSomme();
      }
    };
    onMounted(async () => {
      await vider();
      await charge();
    });

    const vider = async () => {
      options.value = [];
      elements.value = [];
      nombreA.value = null;
      total.value = 0;
      tableau.value = [];
      await charge();
      await mettreAJourOptions();
    };
    const locataire = ref("");
    const numCompte = ref("");
    const emplace = ref("");
    const selectionRadio = ref("Non");
    watch(selectionRadio, (nou, anci) => {
      if (nou !== anci) {
        selectionRadio.value = nou;
        mettreAJourOptions();
      }
    });
    const mettreAJourElement = (data) => {
      // Mettre à jour les données de l'élément dans le tableau
      const index = elements.value.findIndex((e) => e.id === data.id);
      if (index !== -1) {
        elements.value[index] = data;
      }
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<
        HTMLInputElement | HTMLTextAreaElement
      >("input, textarea");
      formFields.forEach((field) => {
        field.value = "";
      });
    };
    return {
      options,
      faireSomme,
      verifierNombreMois,
      selectionRadio,
      mettreAJourElement,
      addArrieresMondalRef,
      vider,
      taux,
      total,
      retirerElement,
      locataire,
      emplace,
      numCompte,
      resetValue,
      soumission,
      elementModified,
      modifNombre,
      ajouterElement,
      ElementVue,
      elements,
      auchangement,
      supprimerElement,
      contratSchema,
      nombreA,
      recupereContrat2,
    };
  },
});
</script>

<style src="@vueform/multiselect/themes/default.css"></style>